var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewalInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.892,
    height: 24.134,
    viewBox: "0 0 23.892 24.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8502",
    "data-name": "Group 8502",
    transform: "translate(-39.5 -768.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8499",
    "data-name": "Group 8499",
    transform: "translate(8057.79 -9759.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M2.756,22.282A2.741,2.741,0,0,1,0,19.526V5.746a1.127,1.127,0,0,1,.1-.494A1.486,1.486,0,0,1,.39,4.836L5.07.338a1.283,1.283,0,0,1,.39-.26A1.47,1.47,0,0,1,5.928,0H14.95a2.741,2.741,0,0,1,2.756,2.756v8.45a1.719,1.719,0,0,0-.65-.078,5.022,5.022,0,0,0-.624.026V2.73a1.454,1.454,0,0,0-1.456-1.456H6.344V3.38A2.774,2.774,0,0,1,3.588,6.136H1.274V19.5A1.454,1.454,0,0,0,2.73,20.956h9.256a6.59,6.59,0,0,0,1.248,1.3H2.756Z",
    transform: "translate(-8018.29 10528.041)",
    fill: "#91919c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16795",
    "data-name": "Rectangle 16795",
    width: 11.654,
    height: 1.114,
    rx: 0.557,
    transform: "translate(-8014.608 10537.621)",
    fill: "#91919c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16796",
    "data-name": "Rectangle 16796",
    width: 12.118,
    height: 1.114,
    rx: 0.557,
    transform: "translate(-8014.608 10540.918)",
    fill: "#91919c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16794",
    "data-name": "Rectangle 16794",
    width: 9.193,
    height: 1.114,
    rx: 0.557,
    transform: "translate(-8014.608 10544.214)",
    fill: "#91919c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6022",
    "data-name": "Path 6022",
    d: "M323.14,259.6a5.5,5.5,0,0,1-.911-.048,6.546,6.546,0,0,1-5.61-6.425,6.473,6.473,0,0,1,6.473-6.52h.24a6.5,6.5,0,0,1-.192,12.993Z",
    transform: "translate(-266.173 533.248)",
    fill: "#91919c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8500",
    "data-name": "Group 8500",
    transform: "translate(51.423 781.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5999",
    "data-name": "Path 5999",
    d: "M223.713,53.15c0,.011.165-.143.165-.132h.956l-1.66,1.923-1.682-1.923h.956c0-.011.209.143.209.132a3.244,3.244,0,0,0-3.166-3.319,3.045,3.045,0,0,0-2.066.813l-.7-.835a4.093,4.093,0,0,1,2.77-1.088,4.333,4.333,0,0,1,4.221,4.429Z",
    transform: "translate(-213.842 -48.722)",
    fill: "#20253a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6000",
    "data-name": "Path 6000",
    d: "M71.12,196.11c0-.011-.165.143-.165.132H70l1.66-1.923,1.682,1.923h-.956c0,.011-.209-.143-.209-.132a3.244,3.244,0,0,0,3.166,3.319,3.045,3.045,0,0,0,2.066-.813l.7.835a4.093,4.093,0,0,1-2.77,1.088,4.333,4.333,0,0,1-4.221-4.429Z",
    transform: "translate(-69.999 -191.462)",
    fill: "#20253a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewalInactive);
export default __webpack_public_path__ + "static/media/renewalInactive.a9f22c352663ef6cc907880c55ff7197.svg";
export { ForwardRef as ReactComponent };